import OnboardingStateConstants from '../constants/OnboardingState.constants';

export default (state = {}, action) => {
  switch (action.type) {
    case OnboardingStateConstants.Actions.ADVANCE_ONBOARDING_STATE_SUCCESS:
    case OnboardingStateConstants.Actions.BACK_ONBOARDING_STATE_SUCCESS:
    case OnboardingStateConstants.Actions.UPDATE_ONBOARDING_STATE_SUCCESS:
      return action.payload;
    case OnboardingStateConstants.Actions.UPDATE_TOPICS_IN_REDUX:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
